import { observable, computed, action } from "mobx";
import { comm } from "../../comm";

export class Account{
	constructor(parent,name, abv){
		this.parent = parent;
		this.name = name;
		this.abv = abv;
		this.lsEntry = 'siu_account_'+name;
		this.localData = JSON.parse(localStorage.getItem(this.lsEntry)) || this.localData;
	}

	@observable profile = {
		displayName: "",
		avatar: ""
	}

	@observable localData = {
		id: '',
		token: '',
		expiration: 0
	}

	@observable.deep serverData = {
		AnonymousUsername: ""
	};

	@computed get isConnected() {
		return this.localData && this.localData.id !== "";
	}

	@observable isLoggedIn = false;

	@action linkAccount(force, accountId, token, expiration){
		return comm.LinkExternal(force, this.abv, accountId)
		.then(() => {
			this.localData = {
				id: accountId,
				token: token,
				expiration
			}
			this.applyToLocalStorage();
		})
	}

	@action.bound getProfileData(){
		return false;
	}

	applyToLocalStorage = () => {
		setPersistentStorage(this.lsEntry, JSON.stringify(this.localData));
	}

	@action.bound changeSIUAccount(){
		return this.linkAccount(true, this.localData.id, this.localData.token, this.localData.expiration)
	}

	getFreshToken(){
		//Specific accounts can test and refresh their session with this.
		//Does not connect or authenticate new accounts as there is no linking flow.
		return Promise.resolve(this.localData.token);
	}

	@action.bound login(siuId,tosId){
		if(this.isConnected || this.name === 'guest'){
			return comm.Login(this.abv,tosId,siuId,this.localData.id)
			.then((response) => {
				this.serverData = response.Payload;
				if(this.name === 'guest'){
					this.localData.id = this.serverData.AnonymousUsername;
					this.applyToLocalStorage()
				}
				//call this to update expired tokens
				return this.getFreshToken()
				.then(() => {
					return this.serverData;
				})
			})
		} else {
			return Promise.resolve(false);
		}
	}


	@action.bound update(accountId, token = "", expiration = 0){
		this.localData = {
			id: accountId,
			token: token,
			expiration
		}
		this.applyToLocalStorage();
	}

	@action.bound reset(){
		this.localData = {
			id: '',
			token: '',
			expiration: 0
		};
	}

	@action.bound disconnect(){
		this.reset();
		this.profile = {
			displayName: "",
			avatar: ""
		};
		this.applyToLocalStorage();
		this.parent.login();
	}
}
